// ─────────────────────────────────────────────
// Grid Point Distance Configuration
// Defines the distance between soil sample
// points in each region based on field data
//C4SEAS grid point distances for Kano and Kaduna
// Kano: Points are 14km apart
// Kaduna: Points are 22km apart
// ─────────────────────────────────────────────

export const GRID_POINT_DISTANCES = {
  kano: 16000, // the project used 14km, but we can use 16km to ensure better coverage
  kaduna: 24000, // the project used 22km, but we can use 24km to ensure better coverage
  default: 20000, // fallback for unknown locations
};

// Determines which radius to use based on location name
// The location name comes from reverse geocoding
// Example: "Zaria, Kaduna State, Nigeria"
export const getRadiusForLocation = (locationName) => {
  if (!locationName) {
    return GRID_POINT_DISTANCES.default;
  }

  // Convert to lowercase for case-insensitive matching
  const lowerName = locationName.toLowerCase();

  // Check if Kano is mentioned in the location name
  if (lowerName.includes("kano")) {
    return GRID_POINT_DISTANCES.kano;
  }

  // Check if Kaduna is mentioned in the location name
  if (lowerName.includes("kaduna")) {
    return GRID_POINT_DISTANCES.kaduna;
  }

  // If neither state is clearly identified, use the default
  return GRID_POINT_DISTANCES.default;
};
